import React, { useState } from "react";
import { Box, Tab, Tabs, Typography } from "@mui/material"
import { TabContext, TabPanel } from "@mui/lab"

import MainContainer from "../../components/Container/MainContainer";
import BlockContainer from "../../components/Container/BlockContainer";
import ChangePassword from "../../components/ChangePassword";
import MyProfile from "../../components/MyProfile";

const Settings = () => {
  const [selectedTab, setSelectedTab] = useState('1');
  return (
    <MainContainer
      sx={{
        padding: { lg: '0 16px 50px' },
      }}
    >
      <BlockContainer
        sx={{
          position: 'relative',
        }}
      >
        <Box
          sx={{
            position: 'relative',
            width: "100%",
            minHeight: "451px",
            padding: '32px 16px',
            borderRadius: { md: '16px' },
            boxShadow: '0px 2px 10px 0px #5B87EF1A',
            bgcolor: 'white'
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <Typography variant="h1">
              Settings
            </Typography>
            <Typography variant="h4" color="primary.darkGray">
              Manage your account settings and preferences
            </Typography>
            
            <Box
              sx={{ 
                width: '100%',
                color: 'white',
                mt: '24px'
              }}
            >
              <TabContext value={selectedTab}>
                <Box sx={{
                  borderBottom: 2,
                  borderColor: 'primary.lightGray',
                }}>
                  <Tabs
                    value={selectedTab}
                    onChange={(e, value) => setSelectedTab(value)}
                    variant="scrollable"
                    scrollButtons="auto"
                    allowScrollButtonsMobile
                    aria-label="notification API tabs"
                    sx={{
                      '& .Mui-selected': {
                        color: '#0E0F10 !important',
                        fontWeight: 600,
                        fontSize: '15px',
                        textTransform: 'capitalize'
                      },
                      '& .MuiTabs-indicator': {
                        background: '#5FB2EC !important',
                        color: '#5FB2EC !important'
                      }
                    }}
                  >
                    <Tab
                      label="My account"
                      value="1"
                      sx={{
                        color: 'primary.darkGray',
                        fontSize: '15px',
                        textAlign: 'left',
                        fontWeight: 500,
                        bgcolor: 'background.default',
                        textTransform: 'capitalize',
                        padding: { md: '16px 26px' }
                      }}
                    />
                    <Tab
                      label="Password"
                      value={"2"} 
                      sx={{
                        color: 'primary.darkGray',
                        fontSize: '15px',
                        fontWeight: 500,
                        bgcolor: 'background.default',
                        textTransform: 'capitalize',
                        padding: { md: '16px 26px' }
                      }}
                    />
                    {/* <Tab 
                      label="Order history" 
                      value="3" 
                      sx={{
                        color: 'primary.darkGray',
                        fontSize: '15px',
                        fontWeight: 500,
                        bgcolor: 'background.default',
                        textTransform: 'capitalize',
                        padding: { md: '16px 26px' }
                      }}
                    /> */}
                    {/* <Tab 
                      label="Notification" 
                      value="4" 
                      sx={{
                        color: 'primary.darkGray',
                        fontSize: '15px',
                        fontWeight: 500,
                        bgcolor: 'background.default',
                        textTransform: 'capitalize',
                        padding: { md: '16px 26px' }
                      }}
                    /> */}
                  </Tabs>
                </Box>
                <Box
                  sx={{
                    '& .MuiTabPanel-root': {
                      padding: 0
                    }
                  }}
                >
                  <TabPanel value="1">
                    <MyProfile />
                  </TabPanel>
                  <TabPanel value="2">
                    <ChangePassword />
                  </TabPanel>
                  <TabPanel value="3">
                    Order History
                  </TabPanel>
                  <TabPanel value="4">
                    Notification
                  </TabPanel>
                </Box>
              </TabContext>
            </Box>
          </Box>
        </Box>
      </BlockContainer>
    </MainContainer>
  );
};

export default Settings;
